import React from 'react';
import { functionRegistry } from '../../utils/functionRegistry';
import { DraggableFunction } from './AvailableFunctions';

const OPERATOR_GROUP_ORDER = ['Comparison', 'Logical', 'Arithmetic'];

type OperatorPaletteProps = {
  setDraggedItem: (item: { type: string; label: string; functionId?: string } | null) => void;
};

const OperatorPalette: React.FC<OperatorPaletteProps> = ({ setDraggedItem }) => {
  const operatorEntries = Array.from(functionRegistry.entries())
    .filter(([, def]) => def.category === 'operator')
    .sort(([, a], [, b]) => {
      const ai = OPERATOR_GROUP_ORDER.indexOf(a.group);
      const bi = OPERATOR_GROUP_ORDER.indexOf(b.group);
      return (ai === -1 ? 999 : ai) - (bi === -1 ? 999 : bi);
    });

  return (
    <div aria-label="Operator palette">
      <p className="text-xs text-ink/70 mb-2">Operators</p>
      <div className="flex flex-wrap gap-2">
        {operatorEntries.map(([id, def]) => (
          <DraggableFunction key={id} id={id} label={def.label} setDraggedItem={setDraggedItem} variant="operator" />
        ))}
      </div>
    </div>
  );
};

export default OperatorPalette;
